import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const planificadorFormularioImporterSelectors = importerSelectors(
  'planificadorFormulario.importer',
);

export default planificadorFormularioImporterSelectors;
